const actions = {
    Add: "FILESELECTION.ADDED",
    Reject: "FILESELECTION.REJECTED",
    Remove: "FILESELECTION.REMOVED"
};

module.exports = actions;


// WEBPACK FOOTER //
// ./src/actions/FileSelectionActions.js